/* global Raven */
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import store from "./store";
import apolloClient from "./apolloClient";
import runtimeEnv from "@mars/heroku-js-runtime-env";
import { ApolloProvider } from "react-apollo";
import { Provider as ReduxProvider } from "react-redux";
import Moment from "react-moment";
import * as serviceWorker from "./registerServiceWorker";
import { getToken } from "./auth";
import { logOut } from "./ducks/auth";

const env = runtimeEnv();

// Set up error reporting
if (typeof Raven !== "undefined") {
  Raven.config("https://88687ffbd85f416d847ae407aaf8efcf@sentry.io/247972", {
    environment: process.env.NODE_ENV,
    release: env.REACT_APP_SLUG_COMMIT
  }).install();
}

const token = getToken();
if (!token || !token.access_token) {
  store.dispatch(logOut());
}

Moment.startPooledTimer();

const render = Component => {
  ReactDOM.render(
    <ReduxProvider store={store}>
      <ApolloProvider client={apolloClient}>
        <Component />
      </ApolloProvider>
    </ReduxProvider>,
    document.getElementById("root")
  );
};

render(App);

if (module.hot) {
  module.hot.accept("./App", () => {
    const NextApp = require("./App").default;
    render(NextApp);
  });
}

serviceWorker.unregister();



// WEBPACK FOOTER //
// ./src/index.js